import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import 'normalize.css'

import App from './App'
import {configureStore} from './store'

let store = configureStore()

// .env
// let config = process.env.BOT_CONFIG;
// ReactDOM.render((
//     <Provider store={store}>
//       <App config={config}/>
//     </Provider>)
//   , document.getElementById('db-chat-widget-root'))


// Embedded
export const init = (config) => {
  ReactDOM.render((
    <Provider store={store}>
      <App config={config}/>
    </Provider>), document.getElementById('db-chat-widget-root'))
}


// WEBPACK FOOTER //
// ./src/index.js